/* eslint-disable react/no-unescaped-entities */
import { routes } from "@/utils/routes";
import dynamic from "next/dynamic";
import Link from "next/link";
import React from "react";

const AgreementPartialLayout = dynamic(
  () => import("../generic/agreement-partial-layout"),
  { ssr: false }
);

const TermsOfUseMain = () => {
  return (
    <AgreementPartialLayout
      title="Terms and Conditions of Use"
      subtitle="Last Updated: February 1st, 2022"
    >
      {({ handleRef }) => (
        <>
          <p style={{ fontWeight: 600 }}>
            The following Terms and Conditions of Use (“Terms” or “Agreement”)
            constitute an agreement between you (“you”) and Shipvista
            Corporation. (“Shipvista.com,” “Company,” “us,” or “our”) and govern
            your use of this website or any software downloaded from this
            website, your Shipvista.com account, your monthly service fee, and
            any and all purchases from or through Shipvista.com (including all
            communications and interactions with the Company and any actions
            taken with respect to any of Company’s advertising). You must read,
            agree with and accept all of the terms and conditions contained in
            the Terms and Privacy Policy before you become a user of our
            products, as they constitute the entire agreement between the
            Company and you with respect to such matters. Company is firmly
            committed to protecting the privacy of your personal information and
            the personal information of your customers. By using the service,
            you acknowledge and agree that Company’s collection, usage and
            disclosure of this personal information is governed by our{" "}
            <Link href={routes.privacyPolicy} target="_blank">
              Privacy Policy
            </Link>
            <br />
            <br />
            The terms Shipvista.com, Company, us and our shall include Shipvista
            Corporation., its representatives, officers, shareholders,
            subsidiaries, parent companies, predecessors, successors,
            affiliates, employees, and agents. These Terms shall apply to
            CrossBorderPost, as defined in Section 11, unless otherwise set
            forth herein. In the event you download our Windows-compatible
            software, you may also be presented a Shipvista.com End User License
            Agreement (the “EULA”). In the event of any conflict between the
            terms of this Agreement and the EULA, these Terms shall govern.
            <br />
            <br />
            IF YOU DO NOT AGREE TO THESE TERMS, DO NOT USE THIS WEBSITE AND DO
            NOT SIGN UP FOR A SHIPVISTA.COM ACCOUNT.
            <br />
            <br />
            <span style={{ fontWeight: 600 }}>
              BOTH YOU AND THE COMPANY AGREE, WITH THE LIMITED EXCEPTIONS NOTED
              BELOW AND AS FURTHER PROVIDED BELOW, TO RESOLVE ALL DISPUTES
              BETWEEN YOU AND THE COMPANY THROUGH BINDING ARBITRATION.
              ARBITRATION MEANS THAT YOU AND THE COMPANY ARE EACH WAIVING THE
              RIGHT TO A JURY TRIAL AND TO PARTICIPATE IN A CLASS ACTION.
            </span>
            <br />
            <br />
          </p>
          <ol>
            <li>
              <h5 id="one" ref={handleRef("SERVICE PRICING", "one") as any}>
                SERVICE PRICING
              </h5>
              Shipvista.com offers a variety of services that may be offered
              individually or bundled – including, without limitation, monthly
              service plans, term service plans, and pre-paid service plans.
              Shipvista.com may offer features or services in addition to the
              existing billed services (“Add-on Services” and together with the
              services, collectively the “Services”). Your service fee, if any,
              will be calculated based on the service plan presented to you and
              agreed to by you during service registration, or during any other
              period where you accept additional services as an existing
              customer. In addition, you are responsible for all variable and
              transactional costs of using your applicable Services (for
              example, postage, fees for carrier services, package insurance,
              items purchased in the online store, direct and indirect costs of
              third party service providers and carriers, transaction fees
              charged directly by Shipvista.com for shipping or other services,
              or other special services selected) in addition to your applicable
              service fees, if any. The total fees quoted for shipping and other
              services may include third party carrier fees, partner and other
              fees charged by Shipvista.com which may not be separately
              delineated from the overall charge. Rates for services charged
              will be based on the rates that are available for your account and
              may be updated by Shipvista.com in its sole discretion.
              Shipvista.com may, at its discretion, offer substitute services
              for any selected Services, with substantially the same or improved
              service levels.
              <br />
              <br />
              Your recurring service fee, if any, will be calculated and billed
              based on the terms of your offer. Unless otherwise indicated in
              the offer, if you have registered for a monthly billing plan (like
              most Shipvista.com users), the monthly billing cycle ends one
              month after you register. For example, if you register on March 8
              the first billing cycle will end April 7, and the second billing
              cycle will begin on April 8. Shipvista.com bills in advance (i.e.,
              at the beginning of the applicable billing cycle) and a pro-rated
              charge for your service fee may apply if you cancel or change your
              plan in the middle of a billing cycle. In addition, Shipvista.com
              may maintain the availability of the service for the full month
              when your account is canceled. If you register for a trial offer,
              but wish to avoid incurring the monthly service fee (including for
              the first month of service), make sure to cancel your account
              before the trial period ends. To cancel, you may cancel online or
              call Shipvista.com customer support at 1- 855-434-3477, Monday -
              Friday, 8:00 AM – 7:30 PM (EST).
              <br />
              <br />
              If you use an Add-on Service that has a charge, then you will be
              billed that additional amount with each billing cycle for as long
              as the Add-on Service is active. The billing details for your
              Add-On Service shall apply as presented to you at the time of your
              acceptance of the Add-on Service and the billing cycle for any
              applicable Add-on Service may differ from your billing cycle for
              other Services or other Add-on Services.
            </li>
            <br />
            <li>
              <h5
                id="two"
                ref={
                  handleRef(
                    "SHIPVISTA.COM ACCOUNT AND POSTAGE ASSIGNMENT",
                    "two"
                  ) as any
                }
              >
                SHIPVISTA.COM ACCOUNT AND POSTAGE ASSIGNMENT
              </h5>
              You must pay for any variable transactional charges relating to
              mailing and shipping (for example, postage) purchased in addition
              to Shipvista.com’s service fee. In order to use Shipvista.com for
              any mailing and shipping services, you must pre-fund your
              Shipvista.com account in an amount equal to or greater than the
              mailing or shipping service to be purchased. All purchases and
              debits will be reflected in your Shipvista.com account balance.
              Please note that the funds may be maintained in a pooled account
              owned by Shipvista.com. In the event of any losses, failure or
              other insolvency of the institutions where funds may be
              maintained, Shipvista.com may be afforded FDIC insurance on the
              account, (individual account holders are not entitled to such
              insurance) and Shipvista.com may then allocate any insurance
              proceeds for the benefit of account holders; however, you may not
              be entitled to receive a refund of all amounts posted with
              Shipvista.com. In the event of any failure or insolvency of
              Shipvista.com, because the amounts held in your Shipvista.com
              account are not insured, they may not be fully refunded.
              <br />
              <br />
              Shipvista.com user accounts are linked to virtual postage meters
              authorized by the U.S. Postal Service (“USPS AND OTHER CARRIER
              SERVICES”). Virtual postage meters permit the printing of PC
              postage; absent such meters, Shipvista.com could not provide the
              services it offers. In certain instances, a virtual postage meter
              may be set up on your behalf and exclusively used to hold your
              account funds and purchase postage on your behalf (a “personal
              virtual postage meter”). In other instances, multiple
              Shipvista.com account holders will be aggregated in a group of
              virtual postage meters, which may be opened and owned in the name
              of Shipvista.com or one of its business partners (an “aggregate
              virtual postage meter”). When you fund your account to conduct
              mailing and shipping transactions, the funds you provide will be
              processed by Shipvista.com and either (i) credited in its general
              account and reflected in your account balance or (ii) funded
              directly to the USPS AND OTHER CARRIER SERVICES and reflected in
              your account balance. Shipvista.com or its business partners will
              separately add funds to the virtual postage meter as needed based
              on your mailing and shipping requests and the requests of other
              accounts assigned to that same aggregate virtual postage meter.
              Shipvista.com or its business partners will ensure that sufficient
              funds are credited to the aggregate virtual postage meter to allow
              you to utilize all of the funds in your Shipvista.com account.
              Please note that Shipvista.com may also apply your payment for
              increases to your Shipvista.com account balance directly to the
              applicable virtual postage meter (personal or aggregate) or into
              Shipvista.com’s general account. Shipvista.com shall have complete
              and absolute discretion in deciding whether to assign you to a
              personal or aggregated virtual postage meter, whether to convert
              you from a personal to aggregated virtual postage meter (or vice
              versa), whether to open a new virtual postage meter or use an
              existing one, whether to open the virtual postage meter in your
              name or to assign you to an existing aggregate virtual postage
              meter, and the name under which the virtual postage meter will be
              activated or maintained. Shipvista.com, moreover, may reassign
              your account from one virtual postage meter to another (whether
              personal or aggregate), from time to time or at any time.
              <br />
              <br />
              Business partners, including mailing and shipping carriers,
              consolidators, resellers, wholesalers, among others, may provide
              certain rates through the virtual postage meters (whether personal
              or aggregate) that may be facilitated by Shipvista.com in its sole
              and absolute discretion. Shipvista.com has the right to bill
              customers for the total listed cost of the services selected,
              including the combined fees of business partners and fees of
              Shipvista.com, without delineating each direct or indirect cost
              separately in its sole and absolute discretion.
              <br />
              <br />
              We do not always provide the lowest rates that may be available
              for your transaction, as rates are dependent on the service you
              choose and a variety of factors driven by your actions in using
              our software and by decisions from Shipvista.com and other
              business partners of Shipvista.com. You agree to the rate provided
              and displayed at the time of the transaction, as that amount may
              fluctuate. No refunds shall be applicable to transactions that
              could have been obtained at a less expensive rate, unless the
              transaction qualifies for a refund as provided for elsewhere in
              our terms.
            </li>
            <br />
            <li>
              <h5
                id="three"
                ref={handleRef("ACCOUNT DURATION", "three") as any}
              >
                ACCOUNT DURATION
              </h5>
              While Shipvista.com reserves the right to cancel your account for
              lack of use, lack of payment, or breach of this Agreement, as a
              general matter, all Shipvista.com user accounts are maintained
              perpetually unless and until cancelled by the user. If you select
              a term service plan or a pre-paid service plan, at the conclusion
              of the term or pre-paid payment period, your account will be
              automatically converted into a monthly service fee account for all
              purposes. Following any account cancellation, Shipvista.com may
              maintain certain account settings and information for a period of
              time in the event of account re-activation. The period of time
              Shipvista.com maintains account information shall be in the sole
              discretion of Shipvista.com.
            </li>
            <br />
            <li>
              <h5 id="four" ref={handleRef("OFFERS", "four") as any}>
                OFFERS
              </h5>
              Some service plans include offers to new or existing customers
              (for example, a digital scale or free postage). Certain offers may
              consist of multiple items. You understand that any such item(s)
              may be provided by either Shipvista.com itself or, in
              Shipvista.com’s sole discretion, its vendor(s). You further
              understand that you may receive, in lieu of any actual item, a
              voucher that you can redeem to receive such item. You also
              understand that you may need to take further action (for example,
              by responding to an email from Shipvista.com) to redeem your
              offer, all as disclosed in the offer details. The offer that you
              have received may not be combined with any other offer, and is not
              transferable and cannot be exchanged or redeemed for cash. Limit
              one (1) offer per user regardless of the number of accounts that
              user or its affiliates register.
              <br />
              <br />
              <span style={{ fontWeight: 600 }}>FREE POSTAGE OFFERS:</span> Free
              postage offers may be granted and shall expire pursuant to the
              terms of the applicable offer (and applicable state or federal
              law). Except where prohibited by applicable law, all unused free
              postage (issued pursuant to a free postage offer) shall expire and
              be deemed forfeited upon cancellation of your Shipvista.com
              account. Other than as set forth in any free postage offer you may
              receive, you are responsible for the cost of the postage itself.
            </li>
            <br />
            <li>
              <h5
                id="five"
                ref={
                  handleRef("ACCOUNT CANCELLATION/TERMINATION", "five") as any
                }
              >
                ACCOUNT CANCELLATION/TERMINATION
              </h5>
              You may terminate or close your account at any time. However,
              depending on the service plan you selected, certain restrictions
              or fees may apply, as detailed below.
              <span style={{ fontWeight: 600 }}>
                {" "}
                To cancel, call Shipvista.com customer support at
                1-855-434-3477, Monday - Friday, 8:00 AM – 7:30 PM (EST).
              </span>{" "}
              Online cancellation options may also be available. You will be
              asked to verify your account information and confirm your intent
              to cancel your account.
              <ul>
                <li>
                  <span style={{ fontWeight: 600 }}>Monthly Service Plan.</span>{" "}
                  You are free to end your monthly service plan at any time. If
                  you terminate your monthly service plan after the applicable
                  trial period, if any, has expired, your account will be
                  handled as follows at the discretion of Shipvista.com: (i)
                  either a pro-rated/partial refund of that month’s service fee
                  will apply and your account will be closed immediately; or
                  (ii) your account will remain open and accessible until the
                  end of that month’s billing cycle, at which point the last
                  monthly service fee (for the preceding month) will be charged
                  and the account will be closed and no longer accessible.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>Term Service Plan.</span> If
                  you terminate your term service plan after the applicable
                  trial period, if any, has expired but before the end of your
                  term, you will be required to pay an early termination fee
                  equal to your monthly billing fee multiplied by the number of
                  months remaining on your term. (If you cancel mid-billing
                  cycle, that month’s billing fee will also be charged in full.)
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>Pre-Paid Plan.</span> If you
                  terminate a pre-paid plan after the applicable trial period,
                  if any, has expired, your account will be closed immediately
                  and you will not receive any refund. Except where prohibited
                  by applicable law, unused free or other postage related to an
                  offer, reflected in your account is never refunded; such
                  credits, if any, expire and are forfeited automatically upon
                  termination of your account. Any monthly service fee credits
                  (for trial periods), if any, are likewise not redeemable or
                  refundable. Non-offer related, non-pre-paid account will be
                  refunded pursuant to USPS AND OTHER CARRIER SERVICES
                  regulations. You may request a refund of your non-offer
                  related postage balance when you call to close your account.
                  If you have unpaid service fees or other outstanding charges,
                  or a user initiated postage refund request is pending (see{" "}
                  <u>
                    User Refunds for Unused on Misprinted Transactions;
                    Destruction of Unused or Misprinted Transactions
                  </u>{" "}
                  below for additional details), your refund, if approved, may
                  be delayed or used to pay, in whole or in part, the
                  outstanding balance.
                </li>
              </ul>
              <br />
              <li>
                <h5
                  id="six"
                  ref={
                    handleRef(
                      "TRIAL OFFER TERMS AND RESTRICTIONS",
                      "six"
                    ) as any
                  }
                >
                  TRIAL OFFER TERMS AND RESTRICTIONS
                </h5>
                <span style={{ fontWeight: 600 }}>
                  {" "}
                  No Risk Trials; the 4 Week Trial:
                </span>{" "}
                If the plan that you select includes a trial offer (for example,
                the “4 week Trial”), you may use our service without incurring a
                service fee charge during the time period specified in your
                trial, beginning from your registration date. If you cancel your
                account before the end of your trial period, you will be charged
                only for any actual shipping and mailing activity or other
                specific transactions; you will not be charged a service fee.{" "}
                <span style={{ fontWeight: 600 }}>
                  However, if you do not cancel your account before the end of
                  your trial period, at the end of the trial period, you will be
                  charged a service fee from the commencement of your service,
                  including for the period of the trial offer. The trial period
                  is not a free period if service is not cancelled before the
                  end of the trial period.
                </span>{" "}
                So, for example, if you are a monthly service fee user who signs
                up for a four week trial offer and you do not cancel within the
                trial period, after the end of the trial period, you will be
                charged (a) a monthly service fee covering the first billing
                cycle including the trial period, and (b) then one month later
                you will be charged the next monthly service fee covering the
                preceding month, and you will continue to be charged a monthly
                service fee unless and until you cancel your account. Each fee
                will be charged at the end of the billing cycle – in other
                words, at the end of the month of service to which the fee
                applies.
                <br />
                <span style={{ fontWeight: 600 }}>Free Trials:</span> If the
                plan you select does offer a “free trial”, then you will not be
                charged a service fee for the period of the free trial offer;
                i.e., even if you fail to cancel following the trial period, you
                will not incur a service fee for the trial time period.
              </li>
              <br />
              <li>
                <h5
                  id="seven"
                  ref={handleRef("METHOD OF PAYMENT", "seven") as any}
                >
                  METHOD OF PAYMENT
                </h5>
                Shipvista.com currently accepts Visa, MasterCard, American
                Express, and Discover. Alternatively, you may set up an
                automated debit from your bank savings or checking account.
                Acceptable payment methods are subject to change at any time.
                You must include correct information (e.g., the address and
                phone number the credit card issuer has on file for you) when
                enrolling. Incorrect information may cause delays in
                establishing service. All information received from you,
                including credit card and/or bank account information, will be
                treated in accordance with Shipvista.com’s Privacy Policy. By
                utilizing our services, you are consenting to be contacted at
                the phone number you select to authenticate such phone number,
                and you will complete the steps required to confirm such
                authentication. If you select to receive a text message,
                wireless and text message fees may apply from your carrier.
                Please note that Shipvista.com may receive updated information
                regarding your payment card account, debit card account or bank
                account from your financial institution and by accepting this
                Agreement you hereby consent to such updating. For example,
                Shipvista.com may receive updated card expiration date or
                account number information. During account registration,
                Shipvista.com may verify that your payment card is valid for the
                service fees associated with your service plan. Shipvista.com
                reserves the right to charge you any unpaid fees or other
                delinquent obligations by your provided payment method
                including, but not limited to, your credit/debit card or direct
                debit from a checking account (ACH) if such checking account
                information has been provided to be debited via ACH by
                Shipvista.com for any purpose. You hereby give Shipvista.com
                permission for such payment method charges or debits to your
                checking account for any overdue fees or other delinquent
                payments owed. The billing entity for part or all of the
                services provided by Company may be that of a subsidiary,
                affiliate or partner organization of Company and you hereby
                consent to any such billing, including changes to the billing
                entity from time to time.
                <br />
                <br />
                <span style={{ fontWeight: 600 }}>DEBIT NOTICE WAIVER:</span> If
                you elect to pay Shipvista.com via a debit card, you hereby
                waive your rights under 12 C.F.R. 205.10(d) to receive ten days’
                advance notice of the amount and date of all varying electronic
                fund transfers, so long as the transfer falls inside the range
                of $0.01 and the sum of any amounts you authorize for insurance
                transactions, mailing and shipping charges, hidden postage
                labels, reset fees or other non-recurring charges.
              </li>
              <br />
              <li>
                <h5
                  id="eight"
                  ref={handleRef("ACCOUNT FUNDING", "eight") as any}
                >
                  ACCOUNT FUNDING
                </h5>
                You may add funds to your Shipvista.com account up to the amount
                of your maximum permitted balance. The minimum purchase (to fund
                your account) and the maximum permitted Shipvista.com account
                balance varies by service program. You may also have the option
                to set your Shipvista.com account to pre-fund automatically when
                the balance is low.
                <br />
                <br />
                With the exception of certain Shipvista.com services, which may
                require you to maintain a minimum balance in your Shipvista.com
                account for a specific duration following the transaction, you
                are allowed to print or create labels up to the current balance
                of pre-funding in your account, as long as all service fees have
                been paid. If any service fee payment cannot be completed
                successfully, your account will be suspended until payment is
                made. You will be notified that your service has been
                temporarily suspended until all overdue balances have been paid.
                <br />
                <br />
                If your account balance becomes negative, you authorize
                Shipvista.com to automatically charge your payment method and/or
                seek reimbursement so that the account balance is no longer
                negative (to cover previously selected mailing and shipping
                transactions, short-paid transactions or other requested
                purchases with Shipvista.com). If you utilize services requiring
                a minimum balance, and your account balance falls below that
                minimum, you authorize Shipvista.com to automatically charge
                your payment method and/or seek payment to maintain that minimum
                balance. The minimum additional funding amount for insufficient
                or negative account balances is $10, and you authorize these
                charges whether your Shipvista.com account is active, suspended,
                or canceled.
              </li>
              <br />
              <li>
                <h5 id="nine" ref={handleRef("BILLING DATE", "nine") as any}>
                  BILLING DATE
                </h5>
                Recurring, Service Fee Billing: Shipvista.com’s service fee and
                any other applicable fees due will be automatically charged to
                the account holder’s credit card, debited from the account
                holder’s debit card or collected via Direct Account Withdrawal
                from the account holder’s bank account at the end of each
                billing cycle.
                <br />
                Account Funding and Product Purchase Billing: Purchases for your
                account balance and product purchases, as well as any fees
                related to such purchases, will be charged to the account
                holder’s credit card, debited from the account holder’s debit
                card or collected via Direct Account Withdrawal from the account
                holder’s bank account at the time of purchase.
              </li>
              <br />
              <li>
                <h5
                  id="ten"
                  ref={
                    handleRef(
                      "MAILING & SHIPPING ADJUSTMENT TRANSACTIONS",
                      "ten"
                    ) as any
                  }
                >
                  MAILING {"&"} SHIPPING ADJUSTMENT TRANSACTIONS
                </h5>
                If you use a shipping service that is paid only when the label
                is used or if it is determined by Shipvista.com or a carrier
                partner of Shipvista.com that a mailing or shipping transaction
                did not contain sufficient funds (for example, not enough
                postage to cover a USPS AND OTHER CARRIER SERVICES shipment due
                to an underreporting of weight at time of print, or a change in
                mail class eligibility because of carrier rule changes),
                Shipvista.com may automatically deduct the amount for the unpaid
                or short-paid transaction from your account balance. You will be
                able to review these adjustments in your account history and
                reports. If one or more of these payments cannot be collected
                from your account due to a lack of available funds, your account
                billing method may be charged (with a minimum charge of $10.00)
                until you fund your account to cover all outstanding payments
                and your account may be suspended. Shipvista.com reserves the
                right to retain the services of a collection agency to recover
                the amount due for outstanding payments.
              </li>
              <li>
                <h5
                  id="eleven"
                  ref={
                    handleRef(
                      "CROSSBORDERPOST TRANSACTIONS AND RELATED SERVICES",
                      "eleven"
                    ) as any
                  }
                >
                  CROSSBORDERPOST TRANSACTIONS AND RELATED SERVICES
                </h5>
                Third Party Partners: Certain shipping transactions may be
                offered through our CrossBorderPost service, including but not
                limited to the Global Advantage Program, which enables our
                customers to ship packages from the United States and
                international posts at discounted rates (hereafter,
                “CrossBorderPost”). We act as your carrier and are primarily
                responsible for the fulfillment of the CrossBorderPost services
                offered through our network of third party parcel processing
                facilities that are selected and directed by us. If you ship
                eligible items to a destination through CrossBorderPost, you may
                first be required to ship the item through a third party parcel
                processing facility which will then route the item to the
                destination address. You acknowledge and understand that we may
                direct one or more third-party global shipping provider(s) to
                oversee the processing, customs clearance, and shipment and the
                return of the item so long as your shipment meets the terms and
                conditions of this program and any other applicable third party
                requirements. Eligible shipment items and quantities are
                generally governed by the origin and destination country’s
                postal regulations, import and export laws, rules and
                requirements. Ineligible items that are shipped may be returned,
                seized, destroyed, or disposed of pursuant to such laws, rules
                and requirements. Please contact us for additional information
                about eligible items and quantities. You acknowledge and agree
                that we have the absolute discretion to disable the
                CrossBorderPost service from your account.
                <br />
                Bulk Inbound Shipping Services: If you are using Bulk Inbound
                Shipping Services, such as CrossBorderPost’s SmartSaver service
                or any other branded bulk inbound shipping services offered by
                Shipvista.com, then you are responsible for printing and
                affixing the following two labels: (1) the designated shipping
                label to each parcel, which contains the parcel’s final
                destination address; and (2) the designated third party carrier
                label addressed to the assigned processing facility for the
                receptacle containing the bundled parcels. You may be provided
                USPS AND OTHER CARRIER SERVICES labels for the receptacle(s)
                which must be used by the ship date printed on the label;
                otherwise, the receptacle label(s) will be automatically
                refunded and unusable. If you are not provided with USPS AND
                OTHER CARRIER SERVICES labels, you may be provided with an
                account number for a third party carrier. Such account number
                shall only be used to print shipping labels for the instructed
                service for your receptacle(s) shipped to the processing
                facility. In the event that labels are generated that are not
                used for the Bulk Inbound Shipping Services or the instructed
                service, Shipvista.com will charge you for shipping costs and
                may assess an additional fee and/or disable the program on your
                account. Parcels that do not reach the instructed location
                including parcels that are sent to the incorrect location, may
                not be processed through the bulk inbound shipping services.
                Parcels that do not have the correct bulk inbound shipping label
                may not be processed.
                <br />
                <span style={{ fontWeight: 600 }}>Pickup Services:</span> If you
                are using Pickup Services, such as CrossBorderPost SmartSaver
                Pickup, or any other branded pickup service offered by
                Shipvista.com, then you are still responsible for affixing the
                destination label on each parcel and may be required to bundle
                the parcels into a receptacle or other shipping supplies
                provided by our pickup agent. The receptacle and/or parcels must
                be picked up by our assigned carrier(s) at designated
                time(s)/date(s). In order for the parcel to be picked up
                successfully, you must follow the prescribed procedure for local
                pickup (below). Failure to follow the guidelines, may impact the
                deliverability of the parcels and cost of the services. Each
                parcel will be subject to the same restrictions and policies as
                CrossBorderPost, unless noted otherwise in these Terms.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Procedures for Pickup Services:
                </span>{" "}
                Guidelines for pickup services may be found by clicking{" "}
                <a
                  href="https://goglobalpost.custhelp.com/app/answers/detail/a_id/4717"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
                <br />
                <span style={{ fontWeight: 600 }}>
                  Interchangeability of Services Used:
                </span>{" "}
                Shipvista.com may substitute services in its sole discretion,
                but Shipvista.com generally offers substitute services that are
                similar to the originally selected service. In the event that
                another service is used, commercially reasonable efforts will be
                made to maintain a similar service standard.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Fees and Adjustments:
                </span>{" "}
                Shipvista.com may change prices and fees, in its sole
                discretion, at any time. The fees for CrossBorderPost may
                include both Shipvista.com and third party carrier fees. The
                total of the fees may be included within the shipping rates
                provided to you and will not be separately delineated from the
                overall charge. Rates for services charged will be based on the
                rates that are available for your account and may be updated by
                Shipvista.com in its sole discretion. For parcels where you
                provide incorrect shipping details about the parcel (such as
                weight, address, dimensions, service type or package type),
                CrossBorderPost reserves the right, at its sole discretion, to
                either (i) deliver the parcel(s) at an increased rate that will
                be automatically charged to you, (ii) return the parcel(s) to
                you with the cost of the return and processing of the return
                charged to you, or (iii) destroy or dispose of the parcel(s),
                with the cost charged to you. In the event that the assessed
                rate cannot be calculated using the CrossBorderPost rates (for
                example, in the event that the actual weight of the shipment
                exceeds the maximum weight supported by the program), you will
                be charged for the replacement service, which may include a
                domestic label, if applicable. For example, you might be
                automatically charged for a domestic Priority Mail Retail
                Package (rated based on transportation from your facility to the
                third-party shipping facility, and any balloon/oversized
                surcharges as required per USPS AND OTHER CARRIER SERVICES rates
                and requirements) plus the cost of a Priority Mail International
                Retail Package (rated based on transportation from the
                third-party shipping facility to your intended international
                recipient, plus any balloon/oversized surcharges as required per
                USPS AND OTHER CARRIER SERVICES rates and requirements). Note
                that in the event that Shipvista.com does not supply a domestic
                label, domestic Priority Retail Package rates will not be
                included in any adjustments.
                <br />
                <span style={{ fontWeight: 600 }}>Duties and Taxes:</span> Some
                CrossBorderPost services offer expedited customs clearance which
                require full payment of duties and taxes. CrossBorderPost
                provides various ways to pay duties and taxes, including and not
                limited to: (i) duties and taxes are deducted from your account
                balance; (ii) duties and taxes are collected by CrossBorderPost
                from the recipient before their parcel leaves a CrossBorderPost
                processing facility; (ii) duties and taxes are collected by
                CrossBorderPost by the destination carrier from the recipient at
                the time of delivery. Improper classification of items in your
                parcel could result in adjustments to your account balance, an
                increase in the amount collected from the recipient, delay,
                disposal, or return. Note that due to international currency
                changes, the amounts may vary based on currency conversion at
                the time of your transaction. An additional administration fee
                related to the collection of duties and taxes may also apply. If
                your transaction requires the payment of duties and taxes by the
                recipient and your recipient refuses to pay for those amounts,
                you may be required to pay for the goods to be returned,
                destroyed, or disposed of or for other amounts imposed.
                <br />
                Click{" "}
                <a
                  href="https://www.goglobalpost.com/usps-canada-ddp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>{" "}
                for terms that apply to CrossBorderPost’s Canada Delivered Duty
                Paid Program.
                <br />
                <span style={{ fontWeight: 600 }}>Refunds:</span> No refunds
                shall be applicable for a CrossBorderPost shipment that has been
                provided to any carrier. In addition, no rate credits shall be
                applied in the event your shipment could have qualified for a
                less expensive rate but you did not select that rate.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Undeliverable Parcels:
                </span>{" "}
                A parcel is considered undeliverable if (i) the recipient’s
                address is incomplete, illegible, incorrect or cannot be
                located, (ii) delivery cannot be made because of the
                unavailability or refusal of an appropriate person to accept
                delivery or sign for delivery of the shipment on the initial
                delivery attempt or reattempts, (iii) the parcel is unable to
                clear customs, (iv) the recipient refused to pay for duties and
                taxes as required by that method of delivery, (v) the shipment
                of the parcel would likely cause damage or delay to other
                shipments or goods, or cause injury, (vi) the parcel contains
                restricted, illegal, or otherwise prohibited items, (vii) the
                parcel’s contents or packaging are damaged to the extent that
                re-wrapping is not possible. If the parcel is undeliverable for
                any reason, we may attempt to notify you and to arrange for the
                return of the parcel, subject to any local regulatory
                restrictions. Additionally, we may, in our sole discretion,
                return the parcel to you or destroy or dispose of the parcel.
                You will be liable for any and all costs, charges and fees
                incurred in returning or disposing of an undeliverable parcel.
                <br />
                <span style={{ fontWeight: 600 }}>Parcel Coverage:</span> In the
                event your parcel is lost and/or damaged prior to delivery, the
                CrossBorderPost service offers a limited Parcel Coverage program
                pursuant to the following terms. Note, Parcel Coverage through
                CrossBorderPost is not package insurance. Actual package
                insurance must be added as a separate transaction.
                <br />
                <ul>
                  <li>
                    Parcel Coverage may only be requested for parcels that
                    receive one or more CrossBorderPost tracking events, beyond
                    the initial acceptance event and are either never received
                    by the recipient and/or are damaged.
                  </li>
                  <li>
                    Parcel Coverage will be limited to the sum of the value of
                    the contents as specified on the customs form at the time of
                    shipment less any salvage value (the total amount not to
                    exceed $100 unless indicated otherwise) PLUS the amount the
                    shipper paid for shipping fees for the respective
                    CrossBorderPost service.
                  </li>
                  <li>
                    Requests for Parcel Coverage must be filed between 30 and 90
                    days from the original ship date using the claim form
                    available on our website and must be signed by you and the
                    addressee, click{" "}
                    <a
                      href="https://goglobalpost.custhelp.com/app/answers/detail/a_id/4276/kw/parcel%20coverage"
                      target="_blank"
                      rel="noreferrer"
                    >
                      here
                    </a>{" "}
                    for additional information.
                  </li>
                  <li>
                    In order for CrossBorderPost to consider a claim for damage,
                    the contents, original shipping cartons, and all packaging
                    material must be available to us for inspection. Your claim
                    may be denied if the shipment cannot be made available to us
                    or we find the shipment was not adequately prepared
                    according to the CrossBorderPost Shipment Preparation
                    Guidelines which can be found by clicking{" "}
                    <a
                      href="https://goglobalpost.custhelp.com/app/answers/detail/a_id/4363/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      here
                    </a>
                    .
                  </li>
                  <li>
                    Coverage is not applicable to undeliverable and rejected
                    parcels or parcels that contain restricted, illegal, or
                    otherwise prohibited items.
                  </li>
                  <li>
                    You should review the laws and regulations of the
                    destination country to ensure that your parcels will not be
                    rejected on the basis that it contains restricted, illegal
                    or otherwise prohibited items. In the event that your parcel
                    contains such items, the carrier or customs official
                    reserves the right to dispose of your parcel without any
                    compensation to you.
                  </li>
                </ul>
                <br />
                <span style={{ fontWeight: 600 }}>
                  Appointment of Agent:
                </span>{" "}
                Pursuant to a routed export transaction under the U.S. Export
                Administration Regulations and Foreign Trade Regulations, your
                recipient, as the Foreign Principal Party in Interest, will
                agree to assume responsibility for the export shipment, with
                Shipvista.com’s third party shipping partner(s) acting as your
                recipient’s forwarding agent. You remain liable for the accuracy
                of information you provide about shipments, and you agree to
                provide timely responses to requests for additional information.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Right of Inspection:
                </span>{" "}
                You agree that we, our shipping partners, or any governmental
                authority including customs and security may open and inspect
                your shipment at any time. You acknowledge and agree that
                CrossBorderPost, our shipping partners, or any governmental
                authority may, at its sole discretion, decide to destroy or
                dispose of a parcel in the event a determination is made that
                such destruction or disposal, as the case may be, is required
                (for example, prohibited items are shipped through
                CrossBorderPost or there is suspected fraud associated with the
                transaction).
                <br />
                <span style={{ fontWeight: 600 }}>
                  Sharing of Information:
                </span>{" "}
                Notwithstanding anything in the Shipvista.com Privacy Policy to
                the contrary, you consent to the disclosure of certain
                personally identifiable information, as well as shipping item
                information (including but not limited to recipient and package
                content information), by Shipvista.com and its partners to any
                third party shipping partner utilized as part of the
                CrossBorderPost service, and, in addition to other third parties
                (such as customs and revenue authorities, as well as other
                government agencies), in connection with the processing, export
                and customs clearance, and international transportation of any
                shipment. Shipvista.com cannot control the privacy policies of
                its third party partners and their service providers and you
                hereby waive any claim related to the disclosure of personally
                identifiable or shipment information as part of CrossBorderPost.
                <br />
                <span style={{ fontWeight: 600 }}>Transit Times:</span> Some
                CrossBorderPost transactions may include a quoted transit time,
                which represents an estimate by Shipvista.com for the respective
                service; actual transit times may vary. Weekend days, public
                holidays, bank holidays, delays caused by customs, delays
                attributable to compliance with mandatory local security
                requirements or other events beyond our control are not included
                when we quote door to door delivery times in our published
                literature. The route and the method by which we transport your
                shipment shall be at our sole discretion.
                <br />
                <span style={{ fontWeight: 600 }}>Countries Served:</span> A
                list of countries approved to ship to under this agreement can
                be found by clicking{" "}
                <a
                  href="https://goglobalpost.custhelp.com/app/answers/detail/a_id/4317"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                . We reserve the right to add or remove countries from this list
                at any time.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Additional CrossBorderPost Info:
                </span>{" "}
                Additional information about CrossBorderPost, including policies
                governing eligibility, service delivery times, weight and size
                restrictions, handling of lost, damaged, and undeliverable
                items, rates, shipment insurance, returns, and refunds can be
                found by clicking{" "}
                <a
                  href="http://crossborderpost.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
              </li>
              <br />
              <li>
                <h5
                  id="twelve"
                  ref={
                    handleRef(
                      "USER REFUNDS FOR UNUSED OR MISPRINTED TRANSACTIONS; DESTRUCTION OF UNUSED OR MISPRINTED TRANSACTIONS",
                      "twelve"
                    ) as any
                  }
                >
                  USER REFUNDS FOR UNUSED OR MISPRINTED TRANSACTIONS;
                  DESTRUCTION OF UNUSED OR MISPRINTED TRANSACTIONS
                </h5>
                You may request a refund for mailing and shipping unused
                transactions, subject to the following rules and limitations,
                for any unused or misprinted items:
                <br />
                <br />
                <span style={{ fontWeight: 600 }}>
                  Authorized User Request:
                </span>{" "}
                You acknowledge and agree that Shipvista.com and/or its
                authorized partners, to the extent necessary by any carrier
                service, is appointed to act on your behalf to request and
                obtain refunds. In addition to Shipvista.com’s refund
                requirements set forth in this agreement, refund requests are
                further subject to the rules and requirements of Shipvista.com’s
                third party carrier services, including the USPS AND OTHER
                CARRIER SERVICES. Shipvista.com makes no guarantee that a refund
                will be made.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Unused or Misprinted Postage:
                </span>{" "}
                Unused and/or misprinted mailing and shipping labels or
                “postage” shall be defined as an envelope, label, plain paper,
                label stock containing carrier-compliant labels, or electronic
                image files, with full, intact indicium which is scan-able and
                unused. Postage handled and/or returned to sender shall not be
                considered valid unused and/or misprinted postage.
                <br />
                <span style={{ fontWeight: 600 }}>Time Limit:</span> You must
                complete the refund request within thirty (30) days of
                generating the mailing or shipping label.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Active Account Required:
                </span>{" "}
                Your account must be active and in good standing to request a
                refund and at the time the refund is to be credited to your
                account, in order for the refund to be processed and your
                account to be credited.
                <br />
                <span style={{ fontWeight: 600 }}>Refund Process:</span> Learn
                how to submit your refund request by clicking{" "}
                <a
                  href="https://shipvista.com/help/faq"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                . You must follow all of the steps listed and provide all of the
                required information to initiate and complete your refund
                request, including the return or destruction, if required, of
                the printed or misprinted but unused mailing and shipping
                labels. Incomplete requests will not be processed.
                <br />
                <span style={{ fontWeight: 600 }}>Refund Rejections:</span> You
                take the risk of the carrier partner improperly rejecting a
                refund request. Shipvista.com will not refund the transaction
                unless the relevant carrier partner approves the refund.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Reimbursement of Shipvista.com Account:
                </span>{" "}
                If you manually initiate a refund request and such request is
                completed within thirty (30) days of purchasing/printing the
                label pursuant to Shipvista.com requirements, your account is
                active and in good standing, and the relevant carrier approves
                the refund, Shipvista.com will credit your account for the full
                value of the transaction to be refunded, as approved by the
                carrier. Refund processing times may vary. If you have an
                outstanding balance in any amount (including but not limited to
                for unpaid service fees or unpaid termination fees) you may not
                receive any reimbursement credit until your account is brought
                current. In addition, Shipvista.com may, in its sole discretion,
                deduct such unpaid fees from any refund otherwise due.
                <br />
                <span style={{ fontWeight: 600 }}>
                  Refund Assist Requests:
                </span>{" "}
                If your account is eligible and approved for Refund Assist
                processing, Shipvista.com will identify labels that may be
                eligible for refunds for your review, submit refund requests on
                your behalf, and update your account balance once processed
                refunds are received. Shipvista.com shall charge a fee that may
                be deducted directly from the total refunded amount in your
                account, for all processed automated refunds received through
                the Refund Assist program. Potentially eligible labels will be
                limited to labels that include any form of shipping label
                tracking codes or other identifying characteristics that are
                scanned and generated by Shipvista.com, subject to modification
                at any time at Shipvista.com’s sole discretion.
                <br />
                In the event that labels may be eligible for refunds, you hereby
                authorize Shipvista.com as your agent in fact to submit refund
                requests on your behalf to carriers for such labels without
                further instruction from you and agree to cooperate in
                submitting the refund request and to take all steps necessary to
                perfect the refund request that may be reasonably requested of
                you. You hereby release Shipvista.com from any responsibility,
                any liability, or any causes of action arising out of or related
                to improper refund requests submitted by Shipvista.com on your
                behalf, including but not limited to refund eligible labels that
                were not identified or refund requests that were denied upon
                submission. It remains your sole responsibility to identify any
                labels that have not been identified and submitted on your
                behalf by Shipvista.com.
                <br />
                Destruction of Unused or Misprinted Postage: All transactions
                printed through Shipvista.com with a designated mailing date,
                expire after that date (USPS AND OTHER CARRIER SERVICES
                transactions expire pursuant to the Code of Federal
                Regulations). USPS AND OTHER CARRIER SERVICES misprinted or
                unused labels must be destroyed or returned to the USPS AND
                OTHER CARRIER SERVICES, as provided in the Domestic Mail Manual
                (see Section 14), regardless of whether a refund is requested.
              </li>
              <br />
              <li>
                <h5
                  id="thirteen"
                  ref={
                    handleRef("PAY-ON-USE SHIPPING LABELS:", "thirteen") as any
                  }
                >
                  PAY-ON-USE SHIPPING LABELS:
                </h5>
                Shipvista.com’s Pay-on-Use shipping label feature, hereafter
                referred to as “Pay-on-Use” is a program offered to qualified
                Shipvista.com customers. This program enables such qualified
                Shipvista.com customers to print service shipping labels (either
                outbound or returns) for which shipping charges are paid when
                the label is scanned by the carrier in the mail stream (known as
                Pay-on-Use), rather than at the time the label is printed (known
                as pre-paid).
                <br />
                <br />
                <span style={{ fontWeight: 600 }}>Payments:</span> Shipvista.com
                will automatically debit the applicable account balance for
                shipping charges and any applicable transaction fees for any
                Pay-On-Use label that is scanned by the carrier in the mail
                stream. Because rates can vary over time, you hereby agree that
                the shipping charges debited from your account balance may be
                calculated based on the customer rate at the time the label is
                scanned by the carrier in the mail stream, not at the time the
                label is printed. In addition to shipping charges and other
                applicable account fees, Shipvista.com reserves the right to
                charge additional fees for participation in the Pay-On-Use
                Program. You are responsible for paying for any Pay-On-Use label
                that is scanned before the applicable label’s expiration date
                (expiration dates vary by carrier).
                <br />
                <span style={{ fontWeight: 600 }}>Restrictions:</span>{" "}
                Pay-on-Use labels designated as return labels shall not be used
                as original outbound shipping labels. Pay-On-Use labels are not
                eligible for refunds. If you participate in the Pay-On-Use
                program, you may be required to maintain balance sufficient to
                cover the cost of the Pay-On-Use labels. Your access to the
                Pay-On-Use program may be disabled immediately if Shipvista.com
                determines, in its sole discretion, that your account is
                delinquent or that you are misusing the Pay-On-Use program.
                <br />
                <span style={{ fontWeight: 600 }}>Termination:</span> Even after
                your account is terminated (by you or Shipvista.com), you must
                still pay for any Pay-On-Use labels that are scanned before the
                labels’ expiration dates.
              </li>
              <br />
              <li>
                <h5
                  id="fourteen"
                  ref={
                    handleRef(
                      "POSTAL POSTAGE ACCOUNT REQUIREMENTS",
                      "fourteen"
                    ) as any
                  }
                >
                  POSTAL POSTAGE ACCOUNT REQUIREMENTS
                </h5>
                By and as a result of accepting these Terms, you are also
                entering into an Agreement with the United States Postal Service
                (USPS AND OTHER CARRIER SERVICES) in accordance with the
                Domestic Mail Manual (DMM) 604.4, Postage Payment Methods,
                Postage Meters and PC Postage Products (Postage Evidencing
                Systems or “PES”). You accept responsibility for control and use
                of your account and the PES printed therefrom. You agree and
                certify that: (i) you will comply with all laws and regulations
                applicable to USPS AND OTHER CARRIER SERVICES, including,
                without limitation, the provisions of the Domestic Mail Manual
                and the International Mail Manual, (ii) you do not owe any money
                to the USPS AND OTHER CARRIER SERVICES and you are not a
                controlling member or officer of an entity that owes money to
                the USPS AND OTHER CARRIER SERVICES, and (iii) you authorize
                Shipvista.com to disclose your personal information to the USPS
                AND OTHER CARRIER SERVICES and such other information retained
                by Shipvista.com that may enable the USPS AND OTHER CARRIER
                SERVICES to collect debts owed to it.
                <br />
                <br />
                You acknowledge that you have read the Domestic Mail Manual
                604.4, Postage Payment Methods, Postage Meters and PC Postage
                Products (Postage Evidencing Systems) and agree to abide by all
                rules and regulations governing its use.
                <br />
                <br />
                Failure to comply with the rules and regulations contained in
                the DMM or use of the PES in any fraudulent or unlawful scheme
                or enterprise may result in the revocation of this agreement.
                <br />
                <br />
                You further acknowledge that any use of this PES that
                fraudulently deprives the USPS AND OTHER CARRIER SERVICES of
                revenue can cause you to be subject to civil and criminal
                penalties applicable to fraud and/or false claims against the
                United States. The submission of a false, fictitious or
                fraudulent statement can result in imprisonment of up to five
                (5) years and fines of up to $10,000 (18 U.S.C. 1001). In
                addition, a civil penalty of up to $5,000 and an additional
                assessment of twice the amount falsely claimed may be imposed (3
                U.S.C. 3802).
                <br />
                <br />
                You further understand that the rules and regulations regarding
                the use of this PES as documented in the DMM may be updated from
                time to time by the USPS AND OTHER CARRIER SERVICES and it is
                your obligation to remain up to date on the rules and
                regulations and to comply with any current and future rules and
                regulations regarding its use.
                <br />
                <br />
                You acknowledge, agree, and warrant that: (1) you bear full
                responsibility and liability for obtaining authorization to
                reproduce and otherwise use the image printed by a postage
                evidencing system as proposed (including, without limitation,
                any trademarks, slogans, likenesses or copyrighted material
                contained in the image); (2) you in fact have the legal
                authority to reproduce and otherwise use the image as proposed;
                and (3) you understand that images or other matter is not
                provided, approved, or endorsed in any way by the Postal
                Service.
              </li>
              <br />
              <li>
                <h5
                  id="fifteen"
                  ref={
                    handleRef(
                      "USE OF SERVICE AND COMPLIANCE WITH LAWS",
                      "fifteen"
                    ) as any
                  }
                >
                  USE OF SERVICE AND COMPLIANCE WITH LAWS
                </h5>
                You represent and warrant that your use of the Services will
                comply with all applicable laws and regulations. You’re
                responsible for determining whether the Services are suitable
                for you to use in light of your obligations under any
                regulations like U.S. state or federal data or privacy laws,
                HIPAA, GLB, EU data privacy laws (including the General Data
                Protection Regulation) (collectively, “EU Data Privacy Laws”),
                United States export control laws and regulations and economic
                sanctions laws and regulations (“U.S. Export Control Laws and
                Regulations”), or other applicable laws. If you’re subject to
                regulations (for example, HIPAA) and you use the Service, then
                we won’t be liable if the Service doesn’t meet those
                requirements. You may not use the Service for any unlawful or
                discriminatory activities, including acts prohibited by the
                Federal Trade Commission Act, Fair Credit Reporting Act, Equal
                Credit Opportunity Act, Children’s Online Privacy Protection
                Act, or other laws that apply to commerce. You will comply with
                CAN-SPAM and any other laws applicable to emailing third
                parties. You will get and maintain all necessary permissions and
                valid consents required to lawfully transfer data to us and to
                enable such data to be lawfully collected, processed, and shared
                for the purposes of providing any Service or as otherwise
                directed by you.
                <br />
                <br />
                If you collect any personal information pertaining to a minor
                and store such information within your account, you represent
                and warrant that you have obtained valid consent from the minor
                according to the applicable laws of the jurisdiction in which
                the minor lives, or that you have otherwise obtained the
                required parental or guardian consent according to the
                applicable laws of the jurisdiction in which the minor lives.
                <br />
                <br />
                If you are located in the European Economic Area, the United
                Kingdom, or Switzerland (collectively, the “EEA”) and/or
                distribute any Campaigns through the Service to anyone located
                in the EEA (each an “EEA Member”), you acknowledge and agree
                that we have your prior written authorization to respond, at our
                discretion, to any data subject access requests we receive from
                your contacts made under EU Data Privacy Laws, or,
                alternatively, we may direct any such contacts to you so that
                you can respond to the request accordingly. “Campaign” is
                defined as an online marketing and transactional email platform
                that allows you to, among other things, create, send and manage
                certain marketing campaigns and mailings.
                <br />
                <br />
                You agree to indemnify and hold us harmless from any losses,
                including all legal fees and expenses that result from your
                breach of this Section 15.
              </li>
              <br />
              <li>
                <h5
                  id="sixteen"
                  ref={
                    handleRef(
                      "ADDITIONAL PRIVACY, EMAIL AND DATA TERMS",
                      "sixteen"
                    ) as any
                  }
                >
                  ADDITIONAL PRIVACY, EMAIL AND DATA TERMS
                </h5>
                By agreeing to these Terms, you promise to follow these rules:
                <ul>
                  <li>
                    You will not send spam. Spam can be in the form of bulk
                    emails or one to one{" "}
                  </li>
                  <li>
                    You will not use purchased, rented, or third-party lists of
                    email addresses.
                  </li>
                  <li>
                    You own or have permission to use all of the material,
                    content, data and information (including your personal
                    information and the personal information of others) you
                    submit to Shipvista.com in the course of using any Service
                    (“Content”).
                  </li>
                  <li>
                    You will not send anything offensive, promote any illegal
                    good or activity, pornography or sexually explicit content
                    and that your use of the Service is not related to the
                    following types of services, products, or content: escort
                    services, mail-order bride/spouse finders, international
                    marriage brokers, and other similar sites and services;
                    hookup, swinger, or sexual encounter sites or services;
                    pharmaceutical products; work from home, make money online,
                    and lead generation opportunities; gambling services or
                    products; multi-level marketing; affiliate marketing; credit
                    repair and get out of debt opportunities; list brokers or
                    list rental services; services selling “Likes” or followers
                    for a social media platform. Also, we do not allow
                    businesses involved in any aspect of the sale, transaction,
                    exchange, storage, marketing or production of
                    crypto-currencies, virtual currencies, and any digital
                    assets related to an Initial Coin Offering, to use
                    Shipvista.com to facilitate or support any of those
                    activities.
                  </li>
                  <li>
                    You will not put into your Campaigns or account any material
                    that was not created by you, provided for you to use, or
                    that would violate the rights of third parties. That
                    includes text, photos, graphics, and other content.
                  </li>
                  <li>
                    You will not use any misleading or incorrect names,
                    addresses, email addresses, subject lines, or other
                    information in the Service or in any Campaigns created,
                    managed or sent using a Service.
                  </li>
                  <li>You will not share your password.</li>
                  <li>
                    You will not use an outside unsubscribe process when sending
                    bulk content to a list hosted in Shipvista.com.
                  </li>
                  <li>
                    You will not set up multiple accounts for any person or
                    entity in order to send similar content, unless you’re part
                    of a franchise or agency.
                  </li>
                  <li>
                    You will not import or incorporate any of this information
                    into any lists, emails or uploads to our servers: Social
                    Security numbers, passwords, security credentials, or
                    sensitive personal information.
                  </li>
                  <li>
                    You will not send Campaigns that will be delivered to
                    recipients as text, SMS, or MMS messages unless using a
                    feature designed for that purpose.
                  </li>
                  <li>
                    You will not upload or send to purchased, rented,
                    third-party, co-reg, publicly available data, or partner
                    lists of any kind.
                  </li>
                  <li>You will not send or forward personal mail.</li>
                  <li>
                    You will not send content created in Shipvista.com through
                    another service.
                  </li>
                  <li>
                    You will not host images on our servers for any purpose
                    other than for your use of the Service.
                  </li>
                  <li>
                    You will not host Content on our servers for any purpose
                    other than for your use of the Service.
                  </li>
                  <li>
                    Except as permitted under our Standard Terms of Use, take
                    any action intended to avoid our billing thresholds.
                    Shipvista.com does not allow accounts that promote or incite
                    harm toward others or that promote discriminatory, hateful,
                    or harassing Content. To this end, we may suspend or
                    terminate your account if you send a Campaign or otherwise
                    distribute any Content that we determine, in our sole
                    discretion, contains either of the following:
                    <ul>
                      <li>
                        A Threat of Physical Harm. This means any statement,
                        photograph, advertisement, or other Content that in our
                        sole judgment could be reasonably perceived to threaten,
                        advocate, or incite physical harm to or violence against
                        others.
                      </li>
                      <li>
                        Hateful Content. This means any statement, image,
                        photograph, advertisement, or other Content that in our
                        sole judgment could be reasonably perceived to harm,
                        threaten, promote the harassment of, promote the
                        intimidation of, promote the abuse of, or promote
                        discrimination against others based solely on race,
                        ethnicity, national origin, sexual orientation, gender,
                        gender identity, religious affiliation, age, disability,
                        disease, or immigration status.
                      </li>
                    </ul>
                    We also may suspend or terminate your account if we
                    determine, in our sole discretion, that you are either:
                  </li>

                  <li>
                    an organization that has publicly stated or acknowledged
                    that its goals, objectives, positions, or founding tenets
                    include statements or principles that could be reasonably
                    perceived to advocate, encourage, or sponsor Hateful Content
                    or A Threat of Physical Harm;
                  </li>
                  <li>
                    a person that has publicly made a comment or statement, or
                    otherwise publicly made known a position, including by
                    membership in an organization as discussed above, that could
                    be reasonably perceived as Hateful Content or A Threat of
                    Physical Harm; or
                  </li>
                  <li>
                    a person or organization that has acted in such a way as
                    could be reasonably perceived to support, condone,
                    encourage, or represent Hateful Content or A Threat of
                    Physical Harm. If you violate any of these rules, then we
                    may suspend or terminate your account.
                  </li>
                </ul>
                <br /> <span style={{ fontWeight: 600 }}> Reporting Abuse</span>
                <br />
                if you think a Shipvista.com customer is violating any of these
                Terms, please notify us immediately. If you received spam you
                think came from a Shipvista.com customer, please report it to
                our customer care team at 1-855-434-3477.
              </li>
              <br />
              <li>
                <h5
                  id="seventeen"
                  ref={handleRef("LEGAL DISCLAIMERS", "seventeen") as any}
                >
                  LEGAL DISCLAIMERS
                </h5>
                <span style={{ fontWeight: 600 }}>
                  {" "}
                  SERVICES PROVIDED “AS IS;” NO REPRESENTATIONS OR WARRANTIES:
                </span>
                <br /> <br />
                THE SHIPVISTA.COM WEBSITE, SHIPVISTA.COM SERVICES, SHIPVISTA.COM
                SOFTWARE, INCLUDING ANY VARIATIONS THEREOF, ANY SITE LINKS AND
                ALL OTHER DOCUMENTATION ARE PROVIDED “AS IS.”
                <br /> <br />
                SHIPVISTA.COM MAKES NO PROMISES, WARRANTIES, OR REPRESENTATIONS
                OF ANY KIND, AND SHIPVISTA.COM SPECIFICALLY DISCLAIMS ALL
                WARRANTIES AND CONDITIONS, EXPRESS, IMPLIED, STATUTORY OR
                OTHERWISE, WITH RESPECT TO THE SUBJECT MATTER HEREOF, INCLUDING
                BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
                <br /> <br />
                SHIPVISTA.COM MAKES NO REPRESENTATION OR WARRANTY THAT THE
                OPERATION OF THE SHIPVISTA.COM WEBSITE, PRODUCTS OR SERVICES
                WILL BE UNINTERRUPTED OR ERROR FREE OR THAT SHIPVISTA.COM
                PRODUCTS AND SERVICES WILL BE AVAILABLE FOR PURCHASE FROM THE
                SHIPVISTA.COM WEBSITE.
                <br /> <br />
                <span style={{ fontWeight: 600 }}>
                  LIMITATION ON DAMAGES:
                </span>{" "}
                WITHOUT LIMITING THE FOREGOING, SHIPVISTA.COM ASSUMES NO
                LIABILITY OR RESPONSIBILITY FOR ANY OF THE FOLLOWING: (A) ERRORS
                OR OMISSIONS IN THE CONTENT DELIVERED BY SHIPVISTA.COM (THROUGH
                ANY MEDIUM); (B) RECOMMENDATIONS OR ADVICE PROVIDED BY CUSTOMER
                SERVICE; (C) ANY FAILURE OR INTERRUPTION IN THE AVAILABILITY OF
                THE SHIPVISTA.COM SERVICE AND/OR WEBSITE OR USER INTERFACES, (D)
                DELIVERY AND OR DISPLAY OF ANY CONTENT OR SERVICES BY
                SHIPVISTA.COM (THROUGH ANY MEDIUM); (E) ANY LOSSES OR DAMAGES
                ARISING FROM THE USE OR VIEWING OF THE CONTENT, SOFTWARE OR
                SERVICES PROVIDED BY SHIPVISTA.COM, INCLUDING BUT NOT LIMITED TO
                ANY LOSSES OR DAMAGES ARISING FROM DOWNLOADING OF SOFTWARE,
                DOWNLOADING AND/OR USE OF ANY OTHER SOFTWARE, OR ANY CONDUCT BY
                USERS OF THE SHIPVISTA.COM SERVICE, WEBSITE OR USER INTERFACES.
                <br />
                IN NO EVENT SHALL SHIPVISTA.COM, OR ANY OF ITS AFFILIATES,
                SERVICE PROVIDERS, OR ANY LICENSORS BE LIABLE (JOINTLY OR
                SEVERALLY) TO YOU FOR PERSONAL INJURY OR ANY SPECIAL,
                INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR
                ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
                PROFITS, BUSINESS INTERRUPTION OR ANY OTHER COMMERCIAL DAMAGES
                OR LOSS, WHETHER OR NOT SHIPVISTA.COM IS ADVISED OF THE
                POSSIBILITY OF SUCH DAMAGE, REGARDLESS OF ANY THEORY OF
                LIABILITY, ARISING OUT OF OR IN ANY WAY CONNECTED WITH USE OR
                PERFORMANCE OF SHIPVISTA.COM’S SERVICES, OUR WEBSITE AND USER
                INTERFACES, AND ALL CONTENTS AND SOFTWARE ASSOCIATED THEREWITH,
                OR OTHERWISE RELATED TO THE SHIPVISTA.COM SERVICE, INCLUDING ANY
                SHIPVISTA.COM STORE PURCHASES OR SPECIAL ITEMS ASSOCIATED
                THEREWITH. IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU FOR ALL
                DAMAGES FOR LOSSES ARISING FROM THE USE OR INABILITY TO USE THE
                SHIPVISTA.COM SERVICE, INCLUDING OUR WEBSITE AND USER
                INTERFACES, AND ALL CONTENT AND SOFTWARE ASSOCIATED THEREWITH
                (OTHER THAN AS MAY BE REQUIRED BY APPLICABLE LAW IN CASES
                INVOLVING PERSONAL INJURY) EXCEED THE AMOUNT OF ONE MONTH’S FEE
                ON YOUR SERVICE PLAN. THE FOREGOING LIMITATIONS WILL APPLY EVEN
                IF THE ABOVE STATED REMEDY FAILS ITS ESSENTIAL PURPOSE. IF ANY
                APPLICABLE AUTHORITY HOLDS ANY PORTION OF THIS SECTION OR OTHER
                SECTIONS OF THESE TERMS OF USE, INCLUDING ANY PORTION OF THE
                PRIVACY POLICY OR ANY APPLICABLE EULA YOU ARE REQUIRED TO AGREE
                TO IN ORDER TO DOWNLOAD SOFTWARE, TO BE UNENFORCEABLE, THEN
                THOSE PORTIONS DEEMED UNENFORCEABLE SHALL BE SEVERED AND THE
                TERMS OF USE SHALL BE ENFORCED ABSENT THOSE PROVISIONS AND ANY
                LIABILITY WILL BE LIMITED TO THE FULLEST POSSIBLE EXTENT
                PERMITTED BY APPLICABLE LAW.
              </li>
              <br />
              <li>
                <h5
                  id="eighteen"
                  ref={
                    handleRef(
                      "DISPUTE RESOLUTION; AGREEMENT TO ARBITRATE; AND CLASS WAIVER",
                      "eighteen"
                    ) as any
                  }
                >
                  DISPUTE RESOLUTION; AGREEMENT TO ARBITRATE; AND CLASS WAIVER
                </h5>
                <span style={{ fontWeight: 600 }}>Agreement to Arbitrate;</span>{" "}
                Class Waiver: You and Shipvista.com agree that, except as
                provided below regarding small claims court proceedings, any
                dispute, claim or controversy arising out of or relating in any
                way to the Shipvista.com services, including, without
                limitation, our PC Postage services, our website, your
                account(s), our Shipvista.com online store, special offers, user
                interfaces, our Privacy Policy or our privacy practices
                generally, these Shipvista.com Terms, and this Agreement to
                Arbitrate, shall be determined by binding arbitration.
                Arbitration is more informal than a lawsuit in court.
                Arbitration uses a neutral arbitrator instead of a judge or
                jury, allows for more limited discovery than in court, and is
                subject to very limited review by courts. YOU AGREE THAT, BY
                AGREEING TO THESE TERMS, THE U.S. FEDERAL ARBITRATION ACT
                GOVERNS THE INTERPRETATION AND ENFORCEMENT OF THIS PROVISION,
                AND THAT YOU AND SHIPVISTA.COM ARE EACH WAIVING THE RIGHT TO A
                TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION. This
                arbitration provision shall survive termination of these Terms
                and the termination of your Shipvista.com account(s).
                <br />
                <span style={{ fontWeight: 600 }}>
                  Pre-filing Mediation.
                </span>{" "}
                In the event of a dispute, prior to initiating arbitration, the
                party asserting the claim must first send to the other, by
                certified mail with return receipt requested (or any successor
                service), a written Notice of claim (“Notice”). If you are the
                claimant, the Notice to Shipvista.com must be addressed to:
                Legal Department - Dispute Resolution, Shipvista Corporation,
                9-9 Royalcrest Rd, Etobicoke, ON M9V 2L6, CANADA. If
                Shipvista.com is the claimant, the Notice must be addressed to
                the address used for your membership account. The Notice must
                (a) describe the nature and basis of the claim or dispute; and
                (b) set forth the specific relief sought. Following receipt of
                the Notice, each party agrees to negotiate with the other in
                good faith about the claim. If the claim is not resolved to the
                satisfaction of the claimant within sixty (60) days after Notice
                is provided, the claimant may pursue the claim in arbitration or
                file a claim in small claims court.
                <br />
                <span style={{ fontWeight: 600 }}>
                  ADDITIONAL ARBITRATION PROVISIONS:
                </span>
                <br />
                <u>Settlement Offers:</u> During the arbitration, the amount of
                any settlement offer made by Shipvista.com or you shall not be
                disclosed to the arbitrator.
                <br />
                <u>Initiating A Claim:</u> The form required to initiate an
                arbitration can be printed or downloaded from{" "}
                <a href="https://www.adr.org/" target="_blank" rel="noreferrer">
                  www.adr.org
                </a>
                . Alternatively, you can contact the arbitration administrator
                by calling 800-778-7879.
                <br />
                <u>Fees for Initiating Arbitration:</u> If you are required to
                pay a filing fee to initiate arbitration, after Shipvista.com
                receives notice of the initiation of arbitration, it will
                promptly reimburse you for your payment of the filing fee at the
                address we have for you on file (or the address provided in the
                Notice), unless your claim is for greater than US $10,000.
                <br />
                <u>Applicable Rules; Administrator:</u> The arbitration will be
                governed by the Commercial Arbitration Rules and the
                Supplementary Procedures for Consumer Related Disputes
                (collectively, “AAA Rules”) of the American Arbitration
                Association (“AAA”), as modified by this Agreement, and will be
                administered by the AAA. The AAA Rules and Forms are available
                online at{" "}
                <a href="https://www.adr.org/" target="_blank" rel="noreferrer">
                  www.adr.org
                </a>
                , by calling the AAA at 1-800-778-7879. The arbitrator is bound
                by the requirements of this Section of the Agreement. All issues
                are for the arbitrator to decide, including issues relating to
                the scope and enforceability of this Agreement to Arbitrate.
                <br />
                <u>Location of Hearing:</u> Unless Shipvista.com and you agree
                otherwise, any arbitration hearings will take place in the
                county (or parish) of your billing address. (If you reside
                outside of the United States, any arbitration hearings will take
                place in your country of residence at a location reasonably
                convenient to you, but will remain subject to the AAA Rules
                including the AAA rules regarding the selection of an
                arbitrator). If your claim is for US $10,000 or less, we agree
                that you may choose whether the arbitration will be conducted
                solely on the basis of documents submitted to the arbitrator,
                through a telephonic hearing, or by an in-person hearing as
                established by the AAA Rules. If your claim exceeds US $10,000,
                the right to a hearing will be determined by the AAA Rules.
                Regardless of the manner in which the arbitration is conducted,
                the arbitrator shall issue a written decision sufficient to
                explain the essential findings and conclusions on which the
                award is based.
                <br />
                <u>Award Enhancement:</u> If the arbitrator issues you an award
                that is greater than the value of Shipvista.com’s last written
                settlement offer made before an arbitrator was selected (or if
                Shipvista.com did not make a settlement offer before an
                arbitrator was selected), then Shipvista.com will pay you the
                amount of the award or US $1,000, whichever is greater. Except
                as expressly set forth herein, the payment of all filing,
                administration and arbitrator fees will be governed by the AAA
                Rules.
                <br />
                <u>Class Waiver:</u> YOU AND SHIPVISTA.COM AGREE THAT EACH MAY
                BRING CLAIMS AGAINST THE OTHER ONLY IN AN INDIVIDUAL CAPACITY
                AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR
                REPRESENTATIVE PROCEEDING. Further, unless both you and
                Shipvista.com agree otherwise, the arbitrator may not
                consolidate the claims of more than one party, and may not
                otherwise preside over any form of a representative or class
                proceeding. If this specific provision is found to be
                unenforceable as applied to any claim asserted by you, the
                remainder of the arbitration provision set forth in this Section
                18 shall still be applicable.
                <br />
                <u>Injunctive Relief Limitation:</u> The arbitrator may award
                declaratory or injunctive relief only in favor of the individual
                party seeking relief and only to the extent necessary to provide
                relief warranted by that party’s individual claim.
                <br />
                <u>Small Claims Procedure Alternative:</u> Notwithstanding the
                foregoing binding arbitration procedure, either party may bring
                an individual action in small claims court (provided the claim
                otherwise qualifies for such program) as an alternative to
                proceeding with arbitration.
              </li>
              <br />
              <li>
                <h5
                  id="nineteen"
                  ref={handleRef("MODIFICATION OF TERMS", "nineteen") as any}
                >
                  MODIFICATION OF TERMS
                </h5>
                Shipvista.com may modify these Terms at any time with 30 days
                advance notice (except in the event changes are required by
                applicable law to go into effect immediately) or upon direct
                acceptance by the user of the modified Terms. The 30 day advance
                notice period will commence when the revised Terms are uploaded
                to Shipvista.com’s website and made accessible to the
                Shipvista.com users. You acknowledge that Shipvista.com may
                change these Terms at any time and from time to time pursuant to
                this provision and that posting the updated Terms on the
                Shipvista.com website shall constitute adequate and sufficient
                notice, and you further agree to check for updates from time to
                time. The date the Terms were last updated will be noted at the
                top of the Terms. Any change shall only apply prospectively.
                Past transactions and interactions shall continue to be governed
                by the Terms in effect when such transaction or interaction
                occurred.
                <br />
                <br />
                Your continued use of the Shipvista.com website and/or service
                (including your account) following the effective date of an
                update to the Terms constitutes your affirmation that you have
                read, understand and accept the revised Terms.
              </li>
              <br />
              <li>
                <h5
                  id="twenty"
                  ref={handleRef("MISCELLANEOUS:", "twenty") as any}
                >
                  MISCELLANEOUS:
                </h5>
                The following miscellaneous terms are fully applicable and
                important. Please read them with the same degree of care you
                read the preceding provisions.
                <br />
                <span style={{ fontWeight: 600 }}>ACCOUNT ACCESS:</span> All
                transactions originating from your account are your
                responsibility.
                <br />
                <span style={{ fontWeight: 600 }}>ACCOUNT DELINQUENCY:</span> If
                you fail to pay your monthly service fee for three months or
                longer or you maintain a negative account balance, Shipvista.com
                may elect, in its sole and absolute discretion, to terminate
                your account. In this event, in addition to all other fees due
                and owing, Shipvista.com shall charge a $25.00 processing fee.
                <br />
                <span style={{ fontWeight: 600 }}>AUTHORITY:</span> By
                completing the registration process, you agree to pay all fees
                incurred on your account in accordance with the terms of the
                service plan selected by you. If you change service plans or
                your account is automatically converted pursuant to Section 3,
                you agree to be bound by the payment terms of the new plan. If a
                Shipvista.com account is established for a business or other
                entity, the person establishing the account represents that he
                or she has all necessary authority to establish an account with
                Shipvista.com on behalf of the business or other entity.
                <br />
                <span style={{ fontWeight: 600 }}>COLLECTION:</span> Each party
                agrees that if timely payment by the other of any amounts due is
                not made, the aggrieved party may pursue the claim directly or
                assign such claim for collection, and the collection agency may
                pursue the collection of the past due amounts and any interest
                or cost of collection permitted by law.
                <br />
                <span style={{ fontWeight: 600 }}>
                  CREDIT VERIFICATION:
                </span>{" "}
                Shipvista.com reserves the right to verify the credit of all
                persons or companies applying for services.
                <br />
                <span style={{ fontWeight: 600 }}>
                  SHIPVISTA.COM INSURANCE:
                </span>{" "}
                All rules, terms and policies related to “Shipvista.com
                Insurance” shall be governed by the Insurance Terms and
                Conditions found on the Shipvista.com website.
                <br />
                <span style={{ fontWeight: 600 }}>
                  LOCATION, USER AND SIZE LIMITATIONS:
                </span>{" "}
                Shipvista.com issues small business/personal accounts and
                corporate accounts, and reserves the right to create and issue
                additional categories of accounts. Users who wish to use their
                account at more than one location (as defined by the single
                9-digit zip code issued by the U.S. Postal Service), or who have
                more than 100 employees, or who wish to have multiple persons
                utilize a single Shipvista.com issued account identifiers, or
                who meet any of the other criteria for establishing a corporate
                account which may be promulgated and posted on the Shipvista.com
                website from time to time, are not eligible for small
                business/personal accounts. Such users must sign up for a
                corporate account. If you qualify for a corporate account,
                please contact Corporate Sales at (877) 395-4917. If you
                nevertheless sign up for a small business/personal account, or
                your company outgrows the limitations set forth in this section,
                a Shipvista.com representative may attempt to contact you to
                reach agreement on an appropriate Corporate Account. Please
                visit the Shipvista.com Corporate Accounts site by{" "}
                <a href="https://www.stamps.com/enterprise/">clicking here</a>{" "}
                for more information on services available to you. Shipvista.com
                may audit your use of the Shipvista.com service governed by
                these Terms to ensure that you are in compliance with the
                Location, User and Size Limitations set forth herein. If
                Shipvista.com determines, in its sole and absolute discretion,
                that you have violated the foregoing limitations, Shipvista.com
                reserves the right to immediately suspend or terminate your
                service/account (without notice) and to collect from you the
                amount that you would have been required to pay under a
                Shipvista.com Corporate Account. If multiple Shipvista.com
                Corporate Account programs are potentially applicable to your
                situation and usage details, Shipvista.com shall have sole and
                absolute discretion to select the program to use in calculating
                the amount due.
                <br />
                <span style={{ fontWeight: 600 }}>
                  NO SUBLICENSE OR THIRD PARTY USE:
                </span>{" "}
                You may use your Shipvista.com account for transactions for your
                own direct use. Shipvista.com does not grant the right to
                sublicense, resell, offer, or utilize any Shipvista.com products
                or services such that Shipvista.com products or services are
                stored, loaded, installed, combined, integrated or displayed as
                part of a product or software offering (including as part of an
                application programming interface) of yours to other third party
                products and services. Shipvista.com does not allow you to
                sublicense, resell, offer, or utilize Shipvista.com products or
                services to third parties (including customers of yours). If
                Shipvista.com determines, in its sole and absolute discretion,
                that you have violated the foregoing limitations, Shipvista.com
                reserves the right to immediately suspend or terminate your
                service/account (without notice).
                <br />
                <span style={{ fontWeight: 600 }}>
                  ORDER ACCEPTANCE/REJECTION:
                </span>{" "}
                Shipvista.com reserves the right at any time after receipt of an
                order for products or services to accept or decline the order
                for any reason.
                <br />
                <span style={{ fontWeight: 600 }}>RELOCATION:</span> You agree
                to provide updated address information to Shipvista.com in the
                event of relocation.
                <br />
                <span style={{ fontWeight: 600 }}>CARRIER TERMS:</span> You
                agree to be bound by the terms and conditions of each carrier
                and partner accessed through Shipvista.com, and must accept such
                terms and conditions prior to using such carrier's services.
                Please note that each carrier may change their terms and
                condition within their sole discretion, and we strongly suggest
                that you visit each carrier's website regularly, to familiarize
                yourself with each company's individual terms and conditions, as
                well as any potential changes, prior to using each service.
                <br />
                <span style={{ fontWeight: 600 }}>RISK OF LOSS:</span> The risk
                of loss and title for non-postage products purchased from
                Shipvista.com passes to you upon our delivery of the purchase to
                our common carrier for delivery to you.
                <br />
                <span style={{ fontWeight: 600 }}>SALES AND USE TAX:</span> No
                sales tax is charged on the purchase of postage. If required by
                applicable law, sales/use/other taxes may be charged/collected
                on non-postage purchases and service fees. You are responsible
                for the payment of all sales, use, or other taxes owed on
                products, services or taxable items purchased or utilized,
                regardless of whether such taxes are collected by Shipvista.com
                at the time of purchase.
                <br />
                <span style={{ fontWeight: 600 }}>SERVICE CHANGES:</span>{" "}
                Shipvista.com reserves the right, periodically and at any time,
                to modify or discontinue, temporarily or permanently, any
                functions and features of its services, in its sole discretion,
                with or without notice, all without liability to you, except
                where prohibited by law. Shipvista.com reserves the right, in
                its sole discretion, to offer selected products from its third
                party partners, including only selected services of the USPS AND
                OTHER CARRIER SERVICES, to each individual customer and does not
                warrant or represent that a full complement of services from
                each partner will be available through Shipvista.com’s services.
                Shipvista.com may, at its discretion, offer substitute services
                for any selected services, with substantially the same or
                improved service levels.
                <br />
                <span style={{ fontWeight: 600 }}>SOFTWARE DOWNLOAD:</span> You
                are not required at this time to download and/or install
                software (or software plug-ins) in order to use Shipvista.com’s
                services. However, downloading software may make certain
                additional Shipvista.com services or features available to you.
                If you download software from the Shipvista.com website, you may
                be asked to accept an end user license agreement as a condition
                to downloading the software. Use of the software is subject to
                the EULA and the terms set forth therein. In the event of a
                conflict between the EULA and these Terms, these Terms shall
                apply.
                <br />
                <span style={{ fontWeight: 600 }}>SOFTWARE USAGE:</span> Subject
                to compliance with this Agreement and the EULA, Shipvista.com
                software (download and/or web access) is provided for no
                additional consideration on a, non-transferable, limited,
                revocable, royalty-free basis.
                <br />
                <span style={{ fontWeight: 600 }}>WEBSITE MISTAKES:</span>{" "}
                Although we make reasonable efforts to provide accurate pricing
                information and product descriptions, pricing mistakes,
                typographical errors or mistakes regarding product availability
                may occur. We reserve the right to correct such mistakes and
                errors.
                <br />
                <span style={{ fontWeight: 600 }}>VIOLATIONS OF LAW:</span>{" "}
                Shipvista.com services may not be used in violation of any law
                or in any way that interferes unreasonably with others’ use of
                the services.
              </li>
              <br />
              <li>
                <h5
                  id="twenty-one"
                  ref={
                    handleRef(
                      "TERMS RELATED TO EUROPEAN UNION DATA PROTECTION LAW",
                      "twenty-one"
                    ) as any
                  }
                >
                  TERMS RELATED TO EUROPEAN UNION DATA PROTECTION LAW
                </h5>
                Additionally, if: (a) you are established in the European Union
                (“EU”); (b) you provide goods or services to customers in the
                EU; or (c) you are otherwise subject to the requirements of the
                EU General Data Protection Regulation (“GDPR”), Company’s
                processing on your behalf of Personal Data which is within the
                territorial scope of the GDPR is also subject to the following
                rules. All defined terms, not otherwise defined herewith shall
                be interpreted in accordance with the GDPR.
                <br />
                <br />
                Before you provide Personal Data of your customers or that of
                other individuals to Company in order for Company to provide
                services, you must be in compliance with the GDPR.
                <br />
                <br />
                You acknowledge that, for the purposes of the GDPR, Company is a
                Processor and you are the Controller of the Personal Data of you
                and your customers, for the purpose of it providing the
                services. Company may share the Personal Data with its agents or
                subcontractors or affiliates or other third party service
                providers for the sole purpose of providing or improving the
                services.
                <br />
                <br />
                In relation to any Personal Data which is within the territorial
                scope of the GDPR provided by you to Company:
                <br />
                <br />
                (i) You warrant, undertake and confirm that you have grounds for
                sharing the Personal Data with Company as envisaged;
                <br />
                <br />
                (ii) You process and control the Personal Data in compliance
                with all applicable laws;
                <br />
                <br />
                (iii) You consent to its use and you have obtained any necessary
                consents from the receiver of the goods (your customer) as
                required under the GDPR to pass to Company the details required
                to complete the services requested, including but not limited to
                name, address, email address, mobile telephone number, and
                contents of package;
                <br />
                <br />
                (iv) You have made your customers aware that such details may be
                used by Company to enhance the delivery process for your
                customers and it may use notifications and geodata for that
                purpose. This may involve Company sharing such details with
                limited third parties’ data processors, for the purpose of
                completing the requested services; and
                <br />
                <br />
                (v) You have told your customers that you use the Company’s
                services, and given them a link to our Privacy Policy.
                <br />
                <br />
                Personal Data of EU Data Subjects that originates in the EU will
                be stored in the EU. As part of providing the services, this
                Personal Data may be transferred to other regions, including the
                United States, subject to the EU-US Privacy Shield or other
                appropriate conditions provided for in Chapter V of the GDPR.
                Prior to any such transfers the Customer will be notified of the
                specific countries to which the data may be transferred and the
                specific legal conditions applicable to the transfers.
                <br />
                <br />
                (vi) Company retains the Personal Data processed on behalf of
                our Customers which is within the territorial scope of the GDPR
                subject to the requests of our Customers, the contractual and
                regulatory obligations to the USPS AND OTHER CARRIER SERVICES,
                our other partners, other legal requirements, and our retention
                schedule.
                <br />
                <br />
                <span style={{ fontWeight: 600 }}>
                  Processing by Company of Personal Data within the Territorial
                  Scope of the GDPR on your behalf
                </span>
                <br />
                <br />
                To the extent that Company in the course of its provision of
                services to you under these terms of service processes on your
                behalf personal data which is within the territorial scope of
                the GDPR, Company will:
                <ul>
                  <li>
                    Process the Personal Data as a Data Processor, only for the
                    purpose of providing the services in accordance with
                    documented instructions from you (provided that such
                    instructions are commensurate with the functionalities of
                    the services), and as may subsequently be agreed to by you.
                    If Company is required by law to Process the Personal Data
                    for any other purpose, Company will provide you with prior
                    notice of this requirement, unless Company is prohibited by
                    law from providing such notice;
                  </li>
                  <li>
                    Ensure that Company’s personnel who access the Personal Data
                    are subject to confidentiality obligations that restrict
                    their ability to disclose Personal Data;
                  </li>
                  <li>
                    Notify you if, in Company’s opinion, your instruction for
                    the processing of Personal Data infringes the GDPR;
                  </li>
                  <li>
                    Notify you promptly, to the extent permitted by law, upon
                    receiving an inquiry or complaint from a Data Subject or
                    Supervisory Authority relating to Company’s Processing of
                    the Personal Data;
                  </li>
                  <li>
                    Implement and maintain appropriate technical and
                    organizational measures to protect the Personal Data against
                    unauthorized or unlawful processing and against accidental
                    loss, destruction, damage, theft, alteration or disclosure.
                    These measures shall be appropriate to the harm which might
                    result from any unauthorized or unlawful processing,
                    accidental loss, destruction, damage or theft of Personal
                    Data and appropriate to the nature of the Personal Data
                    which is to be protected;
                  </li>
                  <li>
                    Notify you promptly upon becoming aware of and confirming
                    any accidental, unauthorized, or unlawful processing of,
                    disclosure of, or access to the Personal Data and, at your
                    cost and request, assist you with the notification of such
                    incidents to data protection supervisory authorities and the
                    persons whose data is affected, where required by the GDPR;
                  </li>
                  <li>
                    Taking into account the nature of Company’s processing
                    activities and at your cost and request, assist you, insofar
                    as this is possible, to fulfill your obligations to respond
                    to requests made by Data Subjects in relation to their
                    rights under Data Protection Laws;
                  </li>
                  <li>
                    Taking into account the nature of Company’s processing
                    activities and at your cost and request, assist you to
                    fulfill your obligations to conduct data protection impact
                    assessments and consult with data protection supervisory
                    authorities in relation to such assessments, where required
                    by the GDPR;
                  </li>
                  <li>
                    At your choice and cost, delete or return all the Personal
                    Data to you on termination of this service agreement, and
                    delete existing copies of such data unless Company is
                    subject to a legal requirement under European Union or
                    Member State law to retain such data beyond such term;
                  </li>
                  <li>
                    At your cost and request, make available to you all
                    information reasonably necessary to demonstrate Company’s
                    compliance with its obligations under (a) through (i) above
                    and allow for and contribute to audits, including
                    inspections, conducted by you or another auditor mandated by
                    you, but in each case only in relation to the Personal Data
                    processed on your behalf by Company in the course of its
                    provision of services under these terms of service.
                  </li>
                </ul>
                <br />
                In the course of providing the services, you acknowledge and
                agree that Company may use Subprocessors to Process the Personal
                Data. Company’s use of any specific Subprocessor to process the
                Personal Data must be in compliance with the GDPR and must be
                governed by a contract between Company and Subprocessor, which
                binds the Subprocessor to comply with the same data protection
                obligations as contained in this Section. Company will inform
                you of any intended changes concerning the addition or
                replacement of such Subprocessors, thereby giving you the
                opportunity to object to such changes.
                <br />
                <br />
                You agree to fully indemnify Company, for any costs, fees,
                fines, and professional fees incurred due to a breach by you of
                the provisions of this Section.
              </li>
            </li>
          </ol>
          <br />
          <br />
          Client also acknowledges that they may not sign up for ShipVista.com
          services if they already maintain an active account with any of the
          carrier's listed in this Disclaimer.
          <br />
          <br />
          As per National Motor Freight Classification 100-AA, Uniform Bill of
          Lading Terms and Conditions, Sec 7(c), "If the description of articles
          or other information on the Bill of Lading is found to be incorrect or
          incomplete, the freight charges must be paid based upon the articles
          actually shipped. As a result, the accuracy of the ShipVista.com quote
          will depend on the information provided by the customer at the time of
          creating the Bill of Lading. This quote will be the basis for the
          initial invoice. All quotes are subject to change based on actual
          differences to weight, piece/pallet count, re-classification, shipping
          dimensions, commodity descriptions, address changes and all other
          charges that occur during transportation (re-delivery, appointment
          request, storage etc.). Further invoices will follow after the initial
          invoice to reflect any additional charges. These charges are due in
          full within the 30 day term of the date of invoice.
          <br />
          <br />
          Actual weights of the individual shipments will be based on the
          relevant carrier's formula for dimensional weights. If the dimensional
          weight exceeds the actual true weight, the carrier's calculation of
          the dimensional weight will always apply. If there is a discrepancy
          between the weight that the client originally entered and the
          carrier's dimensional weight, carrier's dimensional weight will always
          apply. In such cases, the client acknowledges that their credit card
          will be charged the difference between the actual weight and the
          dimensional weight once that data has been provided by the carrier in
          question.
          <br />
          <br />
          Client also acknowledges that they may not sign up for ShipVista.com
          services if they already maintain an active account with any of the
          carrier's listed in this Disclaimer.
          <br />
          <br />
          By using this website and its contents, you automatically agree to its
          terms and conditions.
        </>
      )}
    </AgreementPartialLayout>
  );
};

export default TermsOfUseMain;
